import { IInitEventDisruptionInfo } from 'ngx-mt-ui-lib/api-client';

/** Основная информация карточки ННР без идентификаторов протоколов (они в отдельном слайсе стора). */
export type IDisruptionCardInfo = Omit<
  IInitEventDisruptionInfo,
  'activeProtocolId' | 'histProtocolIdList'
> & {
  userLatitude?: number | null;
  userLongitude?: number | null;
  userAddress?: string | null;
};

export function toDisruptionCardInfo(
  item: IInitEventDisruptionInfo,
): IDisruptionCardInfo {
  const { activeProtocolId: _, histProtocolIdList: __, ...info } = item;
  return info as IDisruptionCardInfo;
}
